<template>
  <div class="page-apply">
    <Breadcrumb :list="list" />
    <div class="apply-content">
      <template v-if="projectContent">
        <div class="c-title">合作项目介绍</div>
        <div class="c-project-c" v-html="projectContent"></div>
      </template>
      <div class="c-title c-title1">合作申请</div>
      <el-form
        class="c-form c-form1"
        ref="form"
        :model="form"
        label-position="top"
        :rules="rules"
      >
        <div class="c-nav c-nav1">一、单位基本信息</div>
        <el-form-item
          class="c-form-item"
          label="联系人姓名"
          prop="contactsName"
        >
          <el-input v-model="form.contactsName" maxlength="120" />
        </el-form-item>
        <el-form-item
          class="c-form-item"
          label="联系人手机号"
          prop="contactsPhone"
        >
          <el-input v-model="form.contactsPhone" maxlength="20" />
        </el-form-item>
        <el-form-item class="c-form-item" label="单位名称" prop="name">
          <el-input v-model="form.name" maxlength="500" />
        </el-form-item>
        <el-form-item
          class="c-form-item"
          label="联系人职务"
          prop="contactsPosition"
        >
          <el-input v-model="form.contactsPosition" maxlength="20" />
        </el-form-item>
        <el-form-item class="c-form-item" label="单位网址" prop="unitWebsite">
          <el-input v-model="form.unitWebsite" maxlength="100" />
        </el-form-item>
        <el-form-item
          class="c-form-item"
          label="法定代表人姓名"
          prop="legalRepresentative"
        >
          <el-input v-model="form.legalRepresentative" maxlength="20" />
        </el-form-item>
        <el-form-item class="c-form-item" label="成立时间" prop="setUpTime">
          <el-date-picker
            v-model="form.setUpTime"
            type="date"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="c-form-item" label="员工总人数" prop="staffSum">
          <el-input v-model="form.staffSum" type="number" maxlength="11" />
        </el-form-item>
        <el-form-item class="c-form-item" label="营业执照号" prop="licenseNum">
          <el-input v-model="form.licenseNum" maxlength="20" />
        </el-form-item>
        <el-form-item class="c-form-item" label="实缴资金（万元）">
          <el-input v-model="form.paidInCapital" maxlength="20" />
        </el-form-item>
        <el-form-item
          class="c-form-item"
          label="社会培训评价组织"
          prop="filingSituation"
        >
          备案情况：
          <el-radio-group
            v-model="form.filingSituation"
            @change="filingSituationChange"
          >
            <el-radio label="1">未在人社局备案</el-radio>
            <el-radio label="2">已在人社局备案</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          class="c-form-item"
          label="注册资金（万元）"
          prop="registeredCapital"
        >
          <el-input v-model="form.registeredCapital" />
        </el-form-item>
        <el-form-item class="c-form-item" label="" prop="evaluableOccupation">
          （人社部第三方）可评价职业（工种）
          <el-input
            :disabled="form.filingSituation === '1'"
            v-model="form.evaluableOccupation"
            placeholder="无"
            maxlength="50"
          />
        </el-form-item>
        <el-form-item class="c-form-item"> </el-form-item>
        <el-form-item
          class="c-form-item1"
          label="营业执照（参照右侧示例）"
          prop="licenseUrl"
        >
          <div class="c-form-item1-content">
            <img
              class="c-form-item1-content-img"
              v-if="form.licenseUrl"
              :src="form.licenseUrl"
              alt="营业执照"
            />
            <Upload v-model="form.licenseUrl" />
            <img
              class="c-form-item1-content-img"
              src="../../assets/image/yyzz-photo.png"
              alt="示例"
            />
          </div>
        </el-form-item>
        <el-form-item
          class="c-form-item1"
          label="法人身份证正面"
          prop="legalRepresentativeIdFront"
        >
          <div class="c-form-item1-content">
            <img
              class="c-form-item1-content-img"
              v-if="form.legalRepresentativeIdFront"
              :src="form.legalRepresentativeIdFront"
              alt="法人身份证正面"
            />
            <Upload v-model="form.legalRepresentativeIdFront" />
            <img
              class="c-form-item1-content-img"
              src="../../assets/image/sfz1.png"
              alt="示例"
            />
          </div>
        </el-form-item>
        <el-form-item
          label="法人身份证反面"
          prop="legalRepresentativeIdReverse"
          class="c-form-item1"
        >
          <div class="c-form-item1-content">
            <img
              class="c-form-item1-content-img"
              v-if="form.legalRepresentativeIdReverse"
              :src="form.legalRepresentativeIdReverse"
              alt="法人身份证反面"
            />
            <Upload v-model="form.legalRepresentativeIdReverse" />
            <img
              class="c-form-item1-content-img"
              src="../../assets/image/sfz2.png"
              alt="示例"
            />
          </div>
        </el-form-item>
        <div class="c-nav c-nav2">二、主营业务信息</div>
        <el-form-item class="c-form-item" label="培训业务经验（年）">
          <el-input v-model="form.trainingBusinessExperience" maxlength="100" />
        </el-form-item>
        <el-form-item class="c-form-item" label="培训模式（面授/远程/综合）">
          <el-input v-model="form.trainingMode" maxlength="20" />
        </el-form-item>
        <el-form-item class="c-form-item" label="培训主题方向">
          <el-input v-model="form.trainingTopics" maxlength="200" />
        </el-form-item>
        <el-form-item class="c-form-item" label="累计培训人次" prop="trainingPersonTimes">
          <el-input v-model="form.trainingPersonTimes" type="number" maxlength="11" />
        </el-form-item>
        <el-form-item class="c-form-item" label="自有授课场地面积">
          <el-input v-model="form.siteArea" maxlength="100" />
        </el-form-item>
        <el-form-item class="c-form-item" label="自有实操场所/设施">
          <el-input v-model="form.operationPlace" maxlength="100" />
        </el-form-item>
        <el-form-item
          class="c-form-item"
          label="最优招生省城或渠道"
          prop="studentsChannel"
        >
          <el-input v-model="form.studentsChannel" maxlength="100" />
        </el-form-item>
        <el-form-item class="c-form-item" />
        <el-form-item
          class="c-form-item1"
          label="培训相关经验或介绍"
          prop="trainingExperienceIntroduce"
        >
          <el-input
            v-model="form.trainingExperienceIntroduce"
            type="textarea"
            maxlength="2000"
          />
        </el-form-item>
        <el-form-item
          class="c-form-item1"
          label="招生资源简要介绍"
          prop="studentsIntroduce"
        >
          <el-input
            v-model="form.studentsIntroduce"
            type="textarea"
            maxlength="2000"
          />
        </el-form-item>
        <el-form-item class="c-form-item1" label="其他主营业务">
          <el-input
            v-model="form.otherBusiness"
            type="textarea"
            maxlength="2000"
          />
        </el-form-item>
        <div class="c-nav c-nav1">三、合作意向</div>
        <el-form-item
          class="c-form-item1"
          label="合作意愿"
          prop="cooperateDesire"
        >
          <el-checkbox-group
            v-model="form.cooperateDesire"
            @change="cooperateDesireChange"
          >
            <el-checkbox
              v-for="item in intendList"
              :key="item.value"
              :label="item.value"
            >
              {{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item class="c-form-item1" label="" prop="otherDesire">
          <el-input
            :disabled="
              !(form.cooperateDesire && form.cooperateDesire.includes('3'))
            "
            v-model="form.otherDesire"
          />
        </el-form-item>
      </el-form>
      <div class="c-submit" @click="handleSubmit">立即合作</div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import * as API from '../../api/cooperation/index'
import Breadcrumb from '../../components/breadcrumb.vue'
import Upload from './upload.vue'
import qs from 'qs'
export default {
  name: 'CooperationApply',
  components: { Breadcrumb, Upload },
  data() {
    return {
      list: [
        {
          label: '合作申请',
          path: '/cooperationApply'
        }
      ],
      projectContent: '',
      form: { cooperateDesire: [], filingSituation: '1' },
      intendList: [
        {
          label: '全媒体运营师培训+考核',
          value: '6'
        },
        {
          label: '网络主播培训+考核',
          value: '7'
        },
        {
          label: '其他',
          value: '8'
        }
      ],
      rules: {
        contactsName: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        contactsPhone: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        contactsPosition: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        unitWebsite: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        legalRepresentative: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        registeredCapital: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        licenseUrl: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        legalRepresentativeIdFront: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        legalRepresentativeIdReverse: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        studentsChannel: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        trainingExperienceIntroduce: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        studentsIntroduce: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        cooperateDesire: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        setUpTime: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        staffSum: [
          { required: true, message: '必填项不可为空', trigger: 'blur' },
          { pattern: /^\d{1,}$/, message: '请输入正整数', trigger: 'blur' }
        ],
        trainingPersonTimes: [
          { pattern: /^\d{1,}$/, message: '请输入正整数', trigger: 'blur' }
        ],
        licenseNum: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        evaluableOccupation: [
          {
            required: false,
            message: '必填项不可为空',
            trigger: 'blur'
          }
        ],
        filingSituation: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        otherDesire: [
          { required: false, message: '必填项不可为空', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getContent()
  },
  methods: {
    async getContent() {
      try {
        const res = await API.getProjectContent()
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          this.projectContent = records[0]?.content ?? ''
        }
      } catch (error) {}
    },
    filingSituationChange(value) {
      this.$set(this.rules, 'evaluableOccupation', [
        {
          required: value === '2',
          message: '必填项不可为空',
          trigger: 'blur'
        }
      ])
    },
    cooperateDesireChange(value) {
      this.$set(this.rules, 'otherDesire', [
        {
          required: value.includes('3'),
          message: '必填项不可为空',
          trigger: 'blur'
        }
      ])
    },
    handleSubmit() {
      const { form } = this
      const script = document.createElement('script')
      script.src = 'https://pv.sohu.com/cityjson?ie=utf-8'
      document.body.appendChild(script)
      script.onload = function () {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            const ip = returnCitySN.cip
            const { cooperateDesire, staffSum, trainingPersonTimes } = form
            const data = {
              ...form,
              cooperateDesire: `${cooperateDesire.toString()}`,
              staffSum: Number(staffSum),
              trainingPersonTimes: trainingPersonTimes
                ? Number(trainingPersonTimes)
                : trainingPersonTimes,
              ip
            }
            try {
              const res = await API.addCooperationApply(data)
              const { code } = res
              if (code === 0) {
                this.$message.success('保存成功')
                this.form = { cooperateDesire: [] }
              }
            } catch (error) {
            } finally {
              document.body.removeChild(script)
            }
          }
        })
      }.bind(this)
    }
  }
}
</script>
<style lang="scss" scoped>
.page-apply {
  padding: 28px 0 50px;
  background: #eef3ff;
  .apply-content {
    box-sizing: border-box;
    width: 1300px;
    margin: 0 auto;
    padding: 20px 88px 108px 88px;
    background: #fff;
    .c-title {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #0853b6;
      margin: 0 auto 50px;
      text-align: center;
    }
    .c-project-c {
      margin: 0 auto 91px;
    }
    .c-title1 {
      margin-bottom: 30px;
    }

    .c-form {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      .c-nav {
        width: 100%;
        height: 54px;
        background: linear-gradient(90deg, #0751b5 0%, #507cf7 100%);
        margin: 0 auto 50px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
        line-height: 54px;
        text-indent: 1rem;
      }
      .c-form-item:nth-child(2n) {
        margin-right: 20%;
      }
      .c-form-item {
        width: 35%;
      }
      .c-form-item1 {
        width: 90%;
        .c-form-item1-content {
          display: flex;
          justify-content: space-between;
          .c-form-item1-content-img {
            width: 280px;
            height: 170px;
            display: block;
          }
        }
      }
    }
    .c-submit {
      width: 200px;
      height: 48px;
      background: linear-gradient(90deg, #0f59be 0%, #496eee 100%);
      box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.08);
      border-radius: 24px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      line-height: 24px;
      line-height: 48px;
      text-align: center;
      margin: 60px auto 0;
      cursor: pointer;
    }
  }
}
</style>
